import api from '../../../utilities/interseptor';

const apiUrl = process.env.REACT_APP_API;

export const getClientes = async (setClientes) => {
    try {
        const res = await api.get(`${apiUrl}/monitor/incidencias/clientes`);
        const opciones = res.data.map((c) => ({
            name: c.EMPRESA,
            code: c.ID,
            logo: c.LOGO,
            iniciales: c.INICIALES,
        }));
        setClientes(opciones);
    } catch (error) {
        console.error('getClientes', error);
    }
};
export const getCausas = async () => {
    try {
        const res = await api.get(`${apiUrl}/monitor/incidencias/causas`);
        return res.data;
    } catch (error) {
        console.error('getCausas', error);
    }
};


export const getDashboardData = async (setData, setLoading, id_cliente, fecha_filtro) => {
    setLoading(true);
    try {
        const [resDetalle, resUnidades, resExcepciones] = await Promise.all([
            api.get(`${apiUrl}/monitor/incidencias/detalle`, {
                params: { id_cliente, fecha_filtro },
            }),
            api.get(`${apiUrl}/monitor/incidencias/unidades-incorrectas`, {
                params: { id_cliente, fecha_filtro },
            }),
            api.get(`${apiUrl}/monitor/incidencias/excepciones`, {
                params: { id_cliente, fecha_filtro },
            }),
        ]);

        setData({
            operador: resDetalle.data.operador ?? [],
            generales: resDetalle.data.generales ?? [],
            excesos_velocidad: resDetalle.data.excesos_velocidad ?? [],
            taxis: resDetalle.data.taxis ?? [],
            servicios_por_proveedor: resDetalle.data.servicios_por_proveedor ?? [],
            unidades_incorrectas:      resUnidades.data ?? [],
            excepciones:               resExcepciones.data ?? [],
            todos_los_servicios:        resDetalle.data.todos_los_servicios ?? [],
            servicios_con_conflicto:   resDetalle.data.servicios_con_conflicto ?? [],
            transferencias:   resDetalle.data.transferencias ?? [],
            rutas_efectividad50:   resDetalle.data.todos_los_servicios?.filter((r) => r?.EFECTIVIDAD_RUTA <= 50) ?? [],
            no_ejecutadas_canceladas:   resDetalle.data.no_ejecutadas_canceladas?? [],
        });
    } catch (error) {
        console.error('getDashboardData', error);
    } finally {
        setLoading(false);
    }
};

// ── Cierres de turno ─────────────────────────────────────────────────────────

export const getCierresTurno = async (setRegistros, setLoading, fecha_inicio, fecha_fin) => {
    setLoading(true);
    try {
        const res = await api.get(`${apiUrl}/monitor/cierre_de_turno`, {
            params: { fecha_inicio, fecha_fin },
        });
        setRegistros(res.data ?? []);
    } catch (error) {
        console.error('getCierresTurno', error);
    } finally {
        setLoading(false);
    }
};

export const createCierreTurno = async (data) => {
    try {
        const res = await api.post(`${apiUrl}/monitor/cierre_de_turno`, data);
        return res.data;
    } catch (error) {
        console.error('createCierreTurno', error);
    }
};
export const getUsuariosIncidente = async (data) => {
    try {
        const res = await api.get(`${apiUrl}/monitor/incidencias/getUsuariosIncidente`, data);
        return res.data;
    } catch (error) {
        console.error('getUsuariosIncidente', error);
    }
};
export const addIncidente = async (data, id_usuario) => {
    const params = {
        id_bitacora: data.bitacora,
        id_usuario_incidente: data.id_usuario_incidente?.code,
        nota: data.nota,
        id_usuario: id_usuario
    }
    try {
        const res = await api.post(`${apiUrl}/monitor/incidencias/agregar-incidente-interno`, params);
        return res.data;
    } catch (error) {
        console.error('addIncidente', error);
    }
};
export const getIncidentesInternas = async (fecha_inicio, fecha_fin) => {
 
    try {
        const res = await api.get(`${apiUrl}/monitor/incidencias/get-incidente-interno?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}`);
        return res.data;
    } catch (error) {
        console.error('getIncidentesInternas', error);
    }
};

export const editarIncidenciaGeneral = async (params) => {
    try {
        const res = await api.put(`${apiUrl}/monitor/incidencias/editar-incidencia`, params);
        return res.data;
    } catch (error) {
        console.error('editarIncidenciaGeneral', error);
    }
};
export const getEfectos = async (id_causa) => {
    try {
        const res = await api.get(`${apiUrl}/monitor/getEfectos?id_causa=${id_causa}`);
        return res.data ?? [];
    } catch (error) {
        console.error('getEfectos', error);
    }
};
export const getTurnoHoy = async () => {
    try {
        const res = await api.get(`${apiUrl}/monitor/incidencias/turno-hoy`);
        return res.data 
    } catch (error) {
        console.error('getTurnoHoy', error);
    }
};

